import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "m54.518 37.734-1.072-1.1A11.86 11.86 0 0 0 39.862 34.4l-.36.177L25.377 20.47l.175-.36A11.92 11.92 0 0 0 20.077 4.2 11.855 11.855 0 0 0 4.2 9.689a11.91 11.91 0 0 0 2.333 13.675L36.616 53.5a11.927 11.927 0 0 0 16.887 0 12 12 0 0 0 1.015-15.766m-4.552 12.23a6.93 6.93 0 0 1-9.813 0L10.06 19.821a6.92 6.92 0 0 1-1.36-7.946A6.854 6.854 0 0 1 17.884 8.7a6.91 6.91 0 0 1 3.173 9.225l-1.735 3.565L38.5 40.643l3.567-1.752a6.86 6.86 0 0 1 7.858 1.294l.727.722a6.99 6.99 0 0 1-.686 9.057",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
